import useTranslatableSelectedLanguage, {
  TranslatableObjectKey,
} from 'hooks/redux/Translatable/useTranslatableLanguages';
import LanguagePicker from 'components/Translatable/LanguagePicker';
import makeStyles from '@material-ui/styles/makeStyles';

const useStyles = makeStyles({
  paragraph: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0',
  },
});

const ParagraphTranslatable = ({ value }) => {
  const classes = useStyles();
  const selectedLanguage = useTranslatableSelectedLanguage();
  const currentValue = value?.[TranslatableObjectKey]?.[selectedLanguage] ?? '';

  return (
    <p className={classes.paragraph}>
      <LanguagePicker /> {currentValue}
    </p>
  );
};

export default ParagraphTranslatable;
